import { render, staticRenderFns } from "./AlertGeneralMessage.vue?vue&type=template&id=af3696c8&scoped=true"
import script from "./AlertGeneralMessage.vue?vue&type=script&lang=js"
export * from "./AlertGeneralMessage.vue?vue&type=script&lang=js"
import style0 from "./AlertGeneralMessage.vue?vue&type=style&index=0&id=af3696c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3696c8",
  null
  
)

export default component.exports